import { object, string } from "yup";
import { StoredDisclaimerProcedure } from "duck";

export const getValidationSchema = (procedure?: StoredDisclaimerProcedure) => {
  const validationSchema = object().shape({
    title: string()
      .default("")
      .required("Procedure type can’t be blank."),
    description: string()
      .default("")
      .required("Procedure description can’t be blank.")
  });

  return {
    validationSchema,
    defaultValues: validationSchema.cast(procedure || {})
  };
};
